import { Link } from "react-router-dom"
import { BreadcrumbNavigation } from "source/shared/components"

export function PageNavigation() {
  return (
    <BreadcrumbNavigation>
      <Link
        to="/giving/profile"
        className="btn secondary-btn minor-btn ml-a as-c"
      >
        My giving
      </Link>
    </BreadcrumbNavigation>
  )
}
